// Labeling in common have fields which is not required and some fields are nested for better structure.

import type { QuestionnaireT } from '../../common/types/types';
export const TRANSCRIPTION_TOOLS = ({
  TRANSCRIPTION: 'TRANSCRIPTION'
} as const);
export const ANNOTATION_LABEL_TYPE = ({
  SPEECH_LABEL: 'SPEECH_LABEL',
  NON_SPEECH_LABEL: 'NON_SPEECH_LABEL'
} as const);
type TranscriptionTool = (typeof TRANSCRIPTION_TOOLS)[keyof typeof TRANSCRIPTION_TOOLS];
export type AnnotationLabel = {
  type: (typeof ANNOTATION_LABEL_TYPE)[keyof typeof ANNOTATION_LABEL_TYPE];
  title: string;
  description?: string;
  questionnaire?: Array<QuestionnaireT>;
  tools: TranscriptionTool[];
  config: LabelConfig;
};
export const INLINE_TAG_TYPE = ({
  FILLER_WORDS: 'FILLER_WORDS',
  NON_SPEECH: 'NON_SPEECH',
  SPEAKER_OVERLAP: 'SPEAKER_OVERLAP'
} as const);
export type InlineTagType = (typeof INLINE_TAG_TYPE)[keyof typeof INLINE_TAG_TYPE];
export type InlineTagOption = {
  type: InlineTagType;
  words: string[];
};
export type InlineTagConfig = {
  [bracketChar: string]: InlineTagOption[];
};
export type InlineTagValidationError = {
  invalidTags: string[];
};
export type LabelInstanceCounts = {
  minInstances: number;
  maxInstances: number;
};
export type LabelConfig = {
  // Allowed minimum media segment length.
  minMediaSegmentLength?: number;
  // Allowed maximum media segment length.
  maxMediaSegmentLength?: number;
  // Allowed minimum text segment length.
  minTextSegmentLength?: number;
  // Allowed maximum segment length.
  maxTextSegmentLength?: number;
  // Allows partial labeling of text, i.e. should allow only selecting words etc.
  allowPartialLabelling: boolean;
  // Should show no entity to label option
  hideNoEntityCheckbox: boolean;
  // Maximum annotation that can created with labels
  maxBoundingBoxes?: number;
  // Is creating at least one annotation is required
  isRequired: boolean;
  // Inline tag configuration for speech segments
  inlineTagConfig?: InlineTagConfig;
  // Instance count constraints (min/max number of annotation instances for this label)
  instanceCounts?: LabelInstanceCounts;
};